import { classNames } from '@/utils';

import type { FutureNetworkType } from '@/types/FutureNetworkType';
import type { SocialProfileNetworkType } from '@/types/socialProfileType';

import Icon from '@/components/base/Icon';
//components
import Instagram from '@/components/icons/Instagram';
import { BlueSkyIcon } from '@/components/icons/Networks/BlueSkyIcon';
import { GoogleAnalyticsIcon } from '@/components/icons/Networks/GoogleAnalyticsIcon';
import { GoogleBusinessIcon } from '@/components/icons/Networks/GoogleBusinessIcon';
import { MastodonIcon } from '@/components/icons/Networks/MastodonIcon';
import { PinterestIcon } from '@/components/icons/Networks/PinterestIcon';
import { QuoraIcon } from '@/components/icons/Networks/QuoraIcon';
import { RedditIcon } from '@/components/icons/Networks/RedditIcon';
import { SnapchatIcon } from '@/components/icons/Networks/SnapchatIcon';
import { TelegramIcon } from '@/components/icons/Networks/TelegramIcon';
import { TwitchIcon } from '@/components/icons/Networks/TwitchIcon';
import { WeChatIcon } from '@/components/icons/Networks/WeChatIcon';
import { WhatsAppIcon } from '@/components/icons/Networks/WhatsAppIcon';
import { YoutubeIcon } from '@/components/icons/Networks/YoutubeIcon';

type NetworkIconProps = {
    network: FutureNetworkType | SocialProfileNetworkType;
} & React.ComponentPropsWithRef<'svg'>;

export function NetworkIcon({ network, ...restProps }: NetworkIconProps) {
    if (network === 'youtube') return <YoutubeIcon {...restProps} />;
    if (network === 'pinterest') return <PinterestIcon {...restProps} />;
    if (network === 'google_analytics') return <GoogleAnalyticsIcon {...restProps} />;
    if (network === 'whats_app') return <WhatsAppIcon {...restProps} />;
    if (network === 'snapchat') return <SnapchatIcon {...restProps} />;
    if (network === 'google_business') return <GoogleBusinessIcon {...restProps} />;
    if (network === 'twitch') return <TwitchIcon {...restProps} />;
    if (network === 'mastodon') return <MastodonIcon {...restProps} />;
    if (network === 'bluesky') return <BlueSkyIcon {...restProps} />;
    if (network === 'we_chat') return <WeChatIcon {...restProps} />;
    if (network === 'telegram') return <TelegramIcon {...restProps} />;
    if (network === 'reddit') return <RedditIcon {...restProps} />;

    if (network === 'instagram') return <Instagram {...restProps} />;

    if (['facebook', 'x', 'twitter', 'linkedin', 'tiktok_business', 'threads'].includes(network)) {
        return (
            <Icon
                icon={network}
                className={classNames(restProps.className, 'dark:text-white', {
                    'text-facebook': network === 'facebook',
                    'text-linkedin': network === 'linkedin',
                    'text-twitter': network === 'x',
                    'text-tiktok': network === 'tiktok_business',
                    'text-threads': network === 'threads'
                })}
            />
        );
    }

    return <QuoraIcon {...restProps} />;
}
